export const INVENTORY_SLOTS = 10;

export interface InventoryItem {
  id: string;
  subtype: string;
  label: string;
  emoji: string;
}

/** Purely client-local, like `myChests`/`myFurniture` — no server sync. */
export function addToInventory(inv: InventoryItem[], item: Omit<InventoryItem, 'id'>): boolean {
  if (inv.length >= INVENTORY_SLOTS) return false;
  inv.push({ id: crypto.randomUUID(), ...item });
  return true;
}

export function removeFromInventory(inv: InventoryItem[], id: string): InventoryItem | null {
  const idx = inv.findIndex(i => i.id === id);
  if (idx === -1) return null;
  return inv.splice(idx, 1)[0];
}
